import React, { FC, useEffect } from 'react';
import { Button, Form, Input, Modal } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { formatJsonStringToCompact, rules } from 'common/helpers';
import { IFormValue } from 'common/models';
import { IUpdateAccountPayload } from 'entities/Account/Account.models';

interface IComponentProps {
  open: boolean;
  loading: boolean;
  metadata?: { [key: string]: any };
  onClose: () => void;
  onSave: (payload: Omit<IUpdateAccountPayload, 'id'>) => void;
}

export const MetaDataChangeModal: FC<IComponentProps> = ({ open, loading, metadata, onClose, onSave }) => {
  const [form] = useForm();

  const handleClose = () => {
    if (loading) {
      return;
    }

    onClose();
    form.resetFields();
  };

  const onSubmit = ({ meta_data }: IFormValue) => {
    const compact = formatJsonStringToCompact(meta_data);
    onSave({ metadata: JSON.parse(compact), onSuccess: handleClose });
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLTextAreaElement>) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData('text');
    const compact = formatJsonStringToCompact(pasted);

    form.setFieldValue('meta_data', compact);
  };

  useEffect(() => {
    if (open && metadata) {
      form.setFieldsValue({ meta_data: JSON.stringify(metadata) });
    }
  }, [open, metadata]);

  return (
    <Modal
      rootClassName="redesign modal"
      width={400}
      title="Настройка meta_data"
      centered
      open={open}
      onCancel={handleClose}
      footer={[
        <Button key="cancel" className="button-sm secondary" onClick={handleClose} disabled={loading}>
          Отмена
        </Button>,
        <Button key="save" className="button-sm primary" loading={loading} onClick={form.submit}>
          Сохранить
        </Button>,
      ]}
    >
      <Form form={form} requiredMark={false} layout="vertical" onFinish={onSubmit}>
        <Form.Item
          label="meta_data"
          name="meta_data"
          rules={[
            rules.required(),
            {
              validator: async (_, value) => {
                if (!value) {
                  return Promise.resolve();
                }

                try {
                  JSON.parse(value);
                  return Promise.resolve();
                } catch {
                  return Promise.reject(new Error('Некорректный JSON'));
                }
              },
            },
          ]}
        >
          <Input.TextArea
            className="autosize-textarea"
            placeholder="Укажите данные в формате JSON"
            autoSize
            style={{ minHeight: 120, maxHeight: 204 }}
            onPaste={handlePaste}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
